module.exports = __webpack_public_path__ + "static/media/29BDOS19.734e098f.jpg";